module.exports = new __parcel__URL__("noIssuesInVersion.348ccc3b.svg").toString();